module.exports = __webpack_public_path__ + "img/doc_1.333622db.png";